import { ExternalOffer } from 'state/loyalty/types';

export const parseExternalIncentiveData = (incentive: ExternalOffer, isOfferClosed: boolean) => {
  // If unauthenticated user content is not configured in Sanity,
  // we will default to closed content regardless of whether it is a closed offer or not
  const unauthenticatedTitle =
    incentive.unauthenticatedUsersContent?.title?.locale ?? incentive.title?.locale;

  const unauthenticatedDescription =
    incentive.unauthenticatedUsersContent?.description?.localeRaw ??
    incentive.description?.localeRaw;
  const incentiveData = {
    title: !isOfferClosed ? incentive.title?.locale : unauthenticatedTitle,
    subtitle: incentive.subtitle,
    description: !isOfferClosed ? incentive.description?.localeRaw : unauthenticatedDescription,
    image: incentive?.image,
    buttonsConfiguration: incentive?.buttonsConfiguration,
    unauthenticatedUsersContent: incentive?.unauthenticatedUsersContent,
    externalOfferModal: incentive?.externalOfferModal,
  };

  return {
    id: incentive?._id,
    backgroundImage: incentive?.backgroundImage,

    ...incentiveData,
  };
};
